const ROOT_API = process.env.VUE_APP_ROOT_API;

const ACT_LPO_API 		= ROOT_API + 'act_lpo/';
const CURRENT_LPO_API = ROOT_API + 'current_lpo/';

// ACT_LPO_API
export const
GET_ACT_LPO = ACT_LPO_API + 'get_act_lpo.php';

// CURRENT_LPO_API
export const 
GET_CURRENT_LPO = CURRENT_LPO_API + 'get_current_lpo.php';
